import { ReactElement } from 'react';

import { AppointmentConfiguration, AppointmentConfigurationQuery } from '@dreryk/egabinet-appointment-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../../translations';

type HealthcareLocationTimetableLoaderRenderer = (renderProps: {
   appointmentConfiguration: AppointmentConfiguration;
}) => ReactElement;

type HealthcareLocationTimetableLoaderProps = {
   readonly children: HealthcareLocationTimetableLoaderRenderer;
};

export const HealthcareLocationTimetableLoader = (props: HealthcareLocationTimetableLoaderProps): JSX.Element => {
   const {
      data: appointmentConfiguration,
      loading: appointmentConfigurationLoading,
      error: appointmentConfigurationError,
   } = useCqrsGet<AppointmentConfiguration>(() => new AppointmentConfigurationQuery());

   if (appointmentConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (appointmentConfigurationError) {
      return (
         <Message
            testId={'failedToFetchSpecialists'}
            label={calendarTranslationKeys.failedToFetchSpecialists}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      appointmentConfiguration: appointmentConfiguration,
   });
};
